import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	// Delete when cleaning up deliveroo_compal_a11y_fixes
	issueIconAltText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// Delete when cleaning up deliveroo_compal_a11y_fixes
	issueIconAltTextIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	workTypeIconAltText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	// Delete when cleaning up deliveroo_compal_a11y_fixes
	issueIconAltText: {
		id: 'command-palette-common.common.command.issue.issue-left-icon.issue-icon-alt-text',
		defaultMessage: 'Icon for the issue type {issueTypeName}',
		description: 'Alternate text for the icon displayed next to the issue',
	},
	// Delete when cleaning up deliveroo_compal_a11y_fixes
	issueIconAltTextIssueTermRefresh: {
		id: 'command-palette-common.common.command.issue.issue-left-icon.issue-icon-alt-text-issue-term-refresh',
		defaultMessage: 'Icon for the work type {issueTypeName}',
		description: 'Alternate text for the icon displayed next to the issue',
	},
	workTypeIconAltText: {
		id: 'command-palette-common.common.command.issue.issue-left-icon.work-type-icon-alt-text',
		defaultMessage: 'Work type {issueTypeName}',
		description: 'Alternate text for the icon indicating the work type of the work item',
	},
});
